
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/update-mode",
      function () {
        return require("private-next-pages/docs/link/update-mode.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/update-mode"])
      });
    }
  